/** ビルド時に注入される設定。 */

function envString(key: string): string | null {
  const value: unknown = (import.meta.env as Record<string, unknown>)[key];
  return typeof value === 'string' && value !== '' ? value : null;
}

/**
 * WebSocket のエンドポイント。
 *
 * 本番は API Gateway の既定エンドポイントを `VITE_WS_URL` で注入する。未設定なら
 * ローカル開発用のサーバを見る。
 */
export const WS_URL: string =
  envString('VITE_WS_URL') ?? `ws://${globalThis.location.hostname}:8787`;

/** HTTP API のベース。既定は同一オリジンの `/api`（開発は Vite が中継、本番は CloudFront）。 */
export const API_BASE: string = envString('VITE_API_BASE') ?? '';
